// @flow
import React from 'react';
import styled from 'styled-components';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Button from '@material-ui/core/Button';
import LabelIcon from '@material-ui/icons/Label';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import SendIcon from '@material-ui/icons/Send';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import format from 'date-fns/format';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

// import OpenIconSpeedDial from '../../components/SpeedDialComponent';

const Footer = styled.div`
  position: fixed;
  bottom: 1rem;
  margin-top: 4rem;
`;

const FooterMenu = styled.div`
  position: relative;
  left: 5%;
`;

const OpenMenuMessage = styled.div`
  position: absolute;
  top: -70px;
  left: 20px;
  width: '15%';
`;

const OpenMenuTag = styled.div`
  position: absolute;
  top: -160px;
  left: 50%;
  width: '100%';
`;

const ButtonStyled = styled(Button)`
  && {
    margin: 0 10px;
  }
`;

type Prop = {
  onClose: Function,
  message: string,
};

function MySnackbarContent(props: Prop) {
  const { message, onClose } = props;

  return (
    <SnackbarContent
      aria-describedby="client-snackbar"
      message={<span id="client-snackbar">{message}</span>}
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>,
      ]}
    />
  );
}

type Props = {
  scribeTagConversation: Function,
  scribeRogerVoiceMessage: Function,
  lang: string,
  tags: Object,
  conversationStarted: ?boolean,
  conversationEnded: ?boolean,
  currentPlatform: string,
  transcripts: TranscriptMap,
  transcriptsCurrent: Array<string>,
  transcriptsFinal: Array<string>,
};
type State = {
  openMessage: boolean,
  openTag: boolean,
  openMessageRogerVoice: boolean,
  openMessageTextCopied: boolean,
};

class ScribeFooterMenu extends React.Component<Props, State> {
  state = {
    openMessage: false,
    openTag: false,
    openMessageRogerVoice: false,
    openMessageTextCopied: false,
  };

  toogleMessageMenu = () => {
    this.setState(state => ({
      openMessage: !state.openMessage,
      openTag: false,
    }));
  };

  toogleTagMenu = () => {
    this.setState(state => ({
      openTag: !state.openTag,
      openMessage: false,
    }));
  };

  handleClickAway = () => {
    this.setState({
      openMessage: false,
      openTag: false,
    });
  };

  handleTagConversation = (tag: Object) => {
    const { scribeTagConversation } = this.props;
    scribeTagConversation(tag);
    this.handleClickAway();
  };

  handleRogerVoiceAnnouncement = () => {
    const { scribeRogerVoiceMessage } = this.props;
    scribeRogerVoiceMessage('announcement');
    this.setState({ openMessageRogerVoice: true });
  };

  handleClose = () => {
    this.setState({
      openMessageRogerVoice: false,
      openMessageTextCopied: false,
    });
  };

  getTranscriptText = () => {
    const { transcripts, transcriptsFinal, transcriptsCurrent, lang } = this.props;
    const text = transcriptsFinal
      .concat(transcriptsCurrent)
      .reduce((acc, tid) => `${acc} \n\r ${transcripts[tid].texts[lang]}`, '');
    const textField = document.createElement('textarea');
    textField.innerText = text;
    const element = document.createElement('a');
    const file = new Blob([text], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    const now = format(new Date(Date.now()), 'dd-MM-yyyy_HH_mm');
    element.download = `transcript-ava-${now}-.txt`;
    element.click();
    this.setState({ openMessageTextCopied: true });
  };

  render() {
    const {
      openMessage,
      openTag,
      openMessageRogerVoice,
      openMessageTextCopied,
    } = this.state;
    const {
      conversationEnded,
      conversationStarted,
      currentPlatform,
      tags,
    } = this.props;
    return (
      <Footer>
        {currentPlatform === 'scribe' && conversationStarted && (
          <FooterMenu>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              open={openMessageRogerVoice}
              autoHideDuration={6000}
              onClose={this.handleClose}
            >
              <MySnackbarContent
                onClose={this.handleClose}
                variant="success"
                message="Audio message has been sent!"
              />
            </Snackbar>
            <ClickAwayListener onClickAway={this.handleClickAway}>
              <div>
                {!conversationEnded && (
                  <ButtonStyled
                    variant="outlined"
                    color="secondary"
                    onClick={this.toogleMessageMenu}
                  >
                    <SendIcon />
                    Message Roger Voice
                  </ButtonStyled>
                )}
                <ButtonStyled
                  variant="outlined"
                  color="secondary"
                  onClick={this.toogleTagMenu}
                >
                  <LabelIcon />
                  Tag Conversation
                </ButtonStyled>

                {openMessage ? (
                  <OpenMenuMessage>
                    <List component="nav">
                      <ListItem
                        button
                        variant="extendedFab"
                        onClick={this.handleRogerVoiceAnnouncement}
                        color="secondary"
                      >
                        <ListItemIcon>
                          <SendIcon />
                        </ListItemIcon>
                        <ListItemText inset primary="Announcement" />
                      </ListItem>
                    </List>
                  </OpenMenuMessage>
                ) : null}
                {openTag ? (
                  <OpenMenuTag>
                    <List component="nav">
                      {(!tags.loadTest || tags.loadTest === undefined) && (
                        <ListItem
                          button
                          variant="extendedFab"
                          onClick={() => {
                            this.handleTagConversation({
                              loadTest: true,
                            });
                          }}
                          color="secondary"
                        >
                          <ListItemIcon>
                            <LabelIcon />
                          </ListItemIcon>
                          <ListItemText inset primary="Tag as Load Test" />
                        </ListItem>
                      )}
                      {(tags.loadTest === undefined || tags.loadTest) && (
                        <ListItem
                          button
                          variant="extendedFab"
                          onClick={() => {
                            this.handleTagConversation({
                              loadTest: false,
                            });
                          }}
                          color="secondary"
                        >
                          <ListItemIcon>
                            <LabelIcon />
                          </ListItemIcon>
                          <ListItemText
                            inset
                            primary="Tag as Normal Conversation"
                          />
                        </ListItem>
                      )}
                    </List>
                  </OpenMenuTag>
                ) : null}
              </div>
            </ClickAwayListener>
          </FooterMenu>
        )}
        {currentPlatform === 'web' &&
          false &&
          conversationStarted &&
          !conversationEnded && [
            <Snackbar
              key="alert1"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              open={openMessageTextCopied}
              autoHideDuration={1000}
              onClose={this.handleClose}
            >
              <MySnackbarContent
                onClose={this.handleClose}
                variant="success"
                message="Text has been saved!"
              />
            </Snackbar>,
            <ButtonStyled
              key="btn2"
              variant="outlined"
              color="secondary"
              onClick={this.getTranscriptText}
            >
              Download text
            </ButtonStyled>,
          ]}
        {/* <OpenIconSpeedDial
              actions={(
                <ButtonStyled
                  key="btn2"
                  variant="outlined"
                  color="secondary"
                  onClick={this.getTranscriptText}
                >
                  Download text
                </ButtonStyled>
)}
            /> */}
      </Footer>
    );
  }
}

export default ScribeFooterMenu;
